<template>
  <div id="movement-item">
    <basic-card :class="'movement-card'">
      <div class="info-part">
        <div class="moving-type">
          <arrow-icon
            v-tooltip="{
              content: $t(
                `storeScreen.boxOverlay.movementItem.movementType.${movement.moved}`
              ),
              trigger: 'click',
              autoHide: true
            }"
            class="moving"
            :movingType="movingType"
            v-if="movement.moved !== 0"
          />
          <img
            class="moving"
            v-tooltip="{
              content: $t(`storeScreen.boxOverlay.movementItem.movementType.0`),
              trigger: 'click',
              autoHide: true
            }"
            src="/static/icons/atStore-icon.svg"
            v-else
          />
        </div>
        <div class="created-at col">
          {{ $moment(movement.date).format("YYYY.MM.DD HH:mm:ss") }}
        </div>
        <div class="partner col" v-if="movement.partner">
          {{ movement.partner.name }}
        </div>
        <div class="creator col">
          <avatar
            :text="movement.creator.fullName"
            :size="'30px'"
            :fontSize="'12px'"
          />
        </div>
      </div>
    </basic-card>
    <div
      class="with-keyboard col"
      v-if="movement.withKeyBoard === 1 && movement.isMobile == 1"
    >
      <img src="/static/icons/keyboard.svg" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BoxesMovementItem",
  props: {
    movement: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    }),
    currentLocation() {
      if (!this.movement) {
        return 3;
      }
      const currentLocation = this.movement;
      if (currentLocation.moved === 0) {
        return 0;
      } else if (currentLocation.moved === 1) {
        return 1;
      } else if (currentLocation.moved === 2) {
        return 2;
      }
      return 3;
    },
    movingType() {
      return this.movement.moved === 1 ? "from" : "to";
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#movement-item {
  margin-bottom: 20px;
  position: relative;
  .movement-card {
    width: 100%;
    .info-part {
      display: flex;
      font-size: 14px;
      text-align: center;
      align-items: center;
      .moving-type {
        margin-right: 5px;
        .moving {
          height: 30px;
          width: 30px;
        }
      }
      .col {
        font-size: 16px;
        font-weight: 550;
        margin-right: 15px;
      }
    }
  }
}
.with-keyboard {
  height: 30px;
  width: 30px;
  position: absolute;
  top: -10px;
  right: -5px;
  background: aliceblue;
  border-radius: 50%;
  padding: 3px;
  border: 1px solid $color-primary;
  img {
    width: 90%;
  }
}
</style>
